import { render, staticRenderFns } from "./ContentTextIndexMobile.vue?vue&type=template&id=b12951d4&"
import script from "./ContentTextIndexMobile.vue?vue&type=script&lang=ts&"
export * from "./ContentTextIndexMobile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VDivider,VSheet})
